/**
 * /tenants/$slug/provisioning — route shim.
 */

import { createFileRoute } from "@tanstack/react-router";
import { fetchConnections, provisioningKeys } from "@/features/provisioning/queries";
import { ConnectionsListPage } from "@/features/provisioning/pages/connections-list-page";

export const Route = createFileRoute("/_authed/tenants/$slug/provisioning/")({
  loader: ({ context }) =>
    context.queryClient.ensureQueryData({
      queryKey: provisioningKeys.list(context.tenant.id),
      queryFn: () => fetchConnections(context.tenant.id),
    }),
  component: ConnectionsListPage,
});
